import uploadsnewspagebannerbgimageshutterstock_2243996415CroppedJpg from "$lib/data/generated/uploads/news/PageBanner/bgImage/shutterstock_2243996415-cropped.jpg";

export const uploads = {
  "uploads/news/PageBanner/bgImage/shutterstock_2243996415-cropped.jpg": uploadsnewspagebannerbgimageshutterstock_2243996415CroppedJpg
};